import { render, staticRenderFns } from "./Pagamentos.vue?vue&type=template&id=7a156b2c&scoped=true&"
import script from "./Pagamentos.vue?vue&type=script&lang=js&"
export * from "./Pagamentos.vue?vue&type=script&lang=js&"
import style0 from "./Pagamentos.vue?vue&type=style&index=0&id=7a156b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a156b2c",
  null
  
)

export default component.exports